type HouseInfo = {
  propertyId: string;
  /** Short label for nav and footer links; `tagline` is far too long. */
  displayName: string;
  tagline: string;
  description: string;
  photos: string[];
  flagPhoto: string;
  route: string;
  allowedAdults: number;
  allowedChildren?: number;
  allowed_guests: number;
  num_bedrooms: number;
  num_beds: number;
  num_baths: number;
  amenities: amenities;
  priceScheme?: pricingSchemeDictionary[];
  icsUrls: string[];
};

type HouseDictionary = {
  [propertyId: string]: HouseInfo;
};

type pricingSchemeDictionary = {
  [key: string]: string;
};

type amenities = {
  essentials?: string[];
  kitchen?: string[];
  entertainment?: string[];
};

const houses: HouseInfo[] = [
  {
    propertyId: "C001",
    displayName: "Beachfront House",
    tagline:
      "Stunning Oceanfront Home With Amazing Views ~ Private Lovely Beach Area",
    description:
      "Stunning oceanfront custom built house with spectacular ocean views. Wake up to the sounds of the ocean and gorgeous view every morning, enjoy sunsets on your deck, take a stroll on miles of sandy beach. The house was custom built in 1997 by Premier McPhee builders and has top-of-the-line quality custom finishes, an incredible gourmet kitchen with granite counter top, Subzero refrigerator, and Viking stoves. It has central air conditioning, high speed internet, and HDTV. It is professionally cleaned and linens/bath towels are provided.",
    photos: [
      "../../featured/beachfront-house-front.jpeg",
      "../../beachfront-house/0165661b.jpg",
      "../../beachfront-house/31962631.jpg",
      "../../beachfront-house/936f5c02.jpg",
      "../../beachfront-house/06b90f7d.jpg",
      "../../beachfront-house/373314a5.jpg",
      "../../beachfront-house/9702033d.jpg",
      "../../beachfront-house/083b17b3.jpg",
      "../../beachfront-house/48192afb.jpg",
      "../../beachfront-house/9a2ce032.jpeg",
      "../../beachfront-house/0de35e4c.jpg",
      "../../beachfront-house/484c2a26.jpg",
      "../../beachfront-house/9c9d97ae.jpg",
      "../../beachfront-house/0fcade34.jpg",
      "../../beachfront-house/4e3e173f.jpg",
      "../../beachfront-house/9cffda80.jpg",
      "../../beachfront-house/123f6a94.jpg",
      "../../beachfront-house/55b2dc5a.jpg",
      "../../beachfront-house/9db07b59.jpg",
      "../../beachfront-house/1580ee72.jpg",
      "../../beachfront-house/72a11fef.jpg",
      "../../beachfront-house/9fd0e889.jpg",
      "../../beachfront-house/16c7c695.jpg",
      "../../beachfront-house/75ebbd7f.jpg",
      "../../beachfront-house/ab176c42.jpg",
      "../../beachfront-house/17ef8e06.jpg",
      "../../beachfront-house/7753b3b6.jpg",
      "../../beachfront-house/c83bd717.jpg",
      "../../beachfront-house/180-e3bf8a94.jpg",
      "../../beachfront-house/78e9b66b.jpg",
      "../../beachfront-house/c8d8403f.jpg",
      "../../beachfront-house/18f25ae5.jpg",
      "../../beachfront-house/799792ee.jpg",
      "../../beachfront-house/cc21f0d3.jpg",
      "../../beachfront-house/1ec47869.jpg",
      "../../beachfront-house/7a335be0.jpg",
      "../../beachfront-house/d58ba93f.jpg",
      "../../beachfront-house/1fb25af8.jpg",
      "../../beachfront-house/7b098d74.jpg",
      "../../beachfront-house/d64f227e.jpg",
      "../../beachfront-house/2288d332.jpg",
      "../../beachfront-house/7c37d667.jpg",
      "../../beachfront-house/dbe888fb.jpg",
      "../../beachfront-house/235e6075.jpg",
      "../../beachfront-house/80d0236c.jpg",
      "../../beachfront-house/dc4bc9ed.jpg",
      "../../beachfront-house/270-1fec51f7.jpg",
      "../../beachfront-house/818f0de3.jpg",
      "../../beachfront-house/df1c9869.jpg",
      "../../beachfront-house/270-32164972.jpg",
      "../../beachfront-house/8cc6559f.jpg",
      "../../beachfront-house/f6142d3a.jpg",
      "../../beachfront-house/270-3cc25ee2.jpg",
      "../../beachfront-house/8f01d72d.jpg",
      "../../beachfront-house/f6aaeb92.jpg",
      "../../beachfront-house/2ec3ab5a.jpeg",
      "../../beachfront-house/8f2ec8f1.jpg",
    ],

    flagPhoto: "featured/beachfront-house-front.jpeg",
    route: "/properties/ocean-one",
    allowedAdults: 8,
    allowedChildren: 5,
    allowed_guests: 10,
    num_bedrooms: 3,
    num_beds: 6,
    num_baths: 5,
    amenities: {
      essentials: [
        "wireless internet",
        "towels",
        "bed sheets",
        "soap",
        "toilet paper",
        "Heating",
        "Air conditioning",
        "Washer",
        "Dryer",
        "Hot water",
        "Hair dryer",
        "Iron",
        "Laptop friendly workspace",
        "Private entrance",
        "Smoke alarm",
        "Carbon monoxide alarm",
        "Fire extinguisher",
      ],
      kitchen: [
        "Refrigerator",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Stove",
        "Coffee maker",
        "Toaster",
        "Ice Maker",
        "Grill",
      ],
      entertainment: [
        "TV",
        "Indoor fireplace",
        "Outdoor firepit",
        "Puzzles and games",
        "Books",
        "Pool table",
        "Foosball table",
      ],
    },
    priceScheme: [
      {
        period: "Jan 2 - Jan 11",
        nightly: "$549",
      },
      {
        period: "Jan 12 - Jan 15",
        nightly: "$699",
      },
      {
        period: "Jan 16 - Feb 29",
        nightly: "$549",
      },
      {
        period: "Mar 1 - May 28",
        nightly: "$549",
        weekend_night: "$559",
      },
      {
        period: "Mar 29 - Apr 4",
        nightly: "$569",
      },
      {
        period: "Apr 5 - Apr 6",
        nightly: "$599",
      },
      {
        period: "Apr 7 - Apr 11",
        nightly: "$579",
      },
      {
        period: "Apr 12 - Apr 20",
        nightly: "$619",
        weekend_night: "$639",
      },
      {
        period: "Apr 21 - Apr 27",
        nightly: "$609",
        weekend_night: "$659",
      },
      {
        period: "Apr 28 - May 4",
        nightly: "$629",
        weekend_night: "$699",
      },
      {
        period: "May 5 - May 11",
        nightly: "$749",
        weekend_night: "$799",
      },
      {
        period: "May 12 - May 18",
        nightly: "$849",
        weekend_night: "$899",
      },
      {
        period: "May 19 - May 23",
        nightly: "$949",
      },
      {
        period: "May 24 - May 27",
        nightly: "$1400",
      },
      {
        period: "May 28 - May 31",
        nightly: "$999",
      },
      {
        period: "Jun 1 - Jun 7",
        nightly: "$999",
      },
      {
        period: "Jun 8 - Jun 14",
        nightly: "$1300",
      },
      {
        period: "Jun 15 - Jun 21",
        nightly: "$1400",
      },
      {
        period: "Jun 15 - Jun 21",
        nightly: "$1400",
        min_stay: "7",
      },
      {
        period: "Jun 22 - Jun 28",
        nightly: "$1500",
        min_stay: "7",
      },
      {
        period: "Jun 29 - Jul 5",
        nightly: "$1790",
        min_stay: "7",
      },
      {
        period: "Jul 5 - Aug 30",
        nightly: "$1720",
        min_stay: "7",
      },
      {
        period: "Aug 31 - Sept 13",
        nightly: "$1600",
        min_stay: "7",
      },
      {
        period: "Sept 14 - Sept 21",
        nightly: "$1200",
        min_stay: "7",
      },
      {
        period: "Sept 22 - Sept 28",
        nightly: "$1500",
        min_stay: "7",
      },
      {
        period: "Sept 29 - Oct 5",
        nightly: "$1100",
        min_stay: "7",
      },
      {
        period: "Oct 6 - Oct 10",
        nightly: "$1040",
      },
      {
        period: "Oct 1 - Oct 14",
        nightly: "$1100",
      },
      {
        period: "Oct 15 - Oct 19",
        nightly: "$999",
      },
      {
        period: "Oct 20 - Oct 25",
        nightly: "$899",
      },
      {
        period: "Oct 26 - Nov 1",
        nightly: "$799",
      },
      {
        period: "Nov 2 - Nov 8",
        nightly: "$749",
      },
      {
        period: "Nov 9 - Nov 15",
        nightly: "$699",
      },
      {
        period: "Nov 16 - Nov 19",
        nightly: "$899",
      },
      {
        period: "Nov 20 - Nov 24",
        nightly: "$110",
      },
      {
        period: "Nov 25 - Nov 30",
        nightly: "$699",
      },
      {
        period: "Dec 1 - Dec 19",
        nightly: "$599",
      },
      {
        period: "Dec 20 - Dec 31",
        nightly: "$1100",
      },
    ],
    icsUrls: [
      "http://www.vrbo.com/icalendar/e6159291c1b848dfb4b9f91771b10062.ics?nonTentative",
    ],
  },
  {
    propertyId: "C004",
    displayName: "Beachfront Penthouse",
    tagline:
      "Cape Cod Oceanfront Beachfront New Penthouse w Ocean View & Private Sandy Beach!",
    description:
      "Brand new 2021 Penthouse: spectacular 180-degree panoramic views of the ocean and private ocean beach on Nantucket Sound. Living, dining, and kitchen directly facing the ocean! Wake up to the sound of the ocean waves and gorgeous view every morning, just steps away from the private ocean beach! Master Bedroom has an ocean view with a queen sized bed, an en-suite full bath with shower/tub combo, a large window, and a smart TV; Bedroom #2 also has an ocean view with a full sized bed and a bunk bed, large window, a smart TV, and a full bath with a shower. In the living room a large sliding glass doors opening to the super-sized balcony with a spectacular 180-degree panoramic view of Nantucket sound. Beautiful kitchen with eat-in area overlooking ocean. An incredible waterfall quartz island. Subzero refrigerator, wolf stove, microwave, wine cooler, and stainless steel appliances. Living room has a smart TV. Central AC, central heating, Washer and Dryer inside the penthouse. Linens and bath towels are provided. The unit is located on the fourth floor. The building has an elevator and stairs.",
    photos: [
      "../../featured/beachfront-penthouse-flag.jpeg",
      "../../beachfront-penthouse/00243eea.jpg",
      "../../beachfront-penthouse/0223d953.jpg",
      "../../beachfront-penthouse/087ce1ae.jpg",
      "../../beachfront-penthouse/0e257f25.jpg",
      "../../beachfront-penthouse/12d0a4f5.jpg",
      "../../beachfront-penthouse/19689768.jpg",
      "../../beachfront-penthouse/234402a7.jpg",
      "../../beachfront-penthouse/28231526.jpg",
      "../../beachfront-penthouse/2fff9dc1.jpg",
      "../../beachfront-penthouse/303be957.jpg",
      "../../beachfront-penthouse/30e4f373.jpg",
      "../../beachfront-penthouse/32e5e08b.jpg",
      "../../beachfront-penthouse/35a901e1.jpg",
      "../../beachfront-penthouse/3a419c3d.jpg",
      "../../beachfront-penthouse/3a46d49e.jpg",
      "../../beachfront-penthouse/3bca0207.jpg",
      "../../beachfront-penthouse/403b4f7b.jpg",
      "../../beachfront-penthouse/471e165b.jpg",
      "../../beachfront-penthouse/48e8a7f8.jpg",
      "../../beachfront-penthouse/4a385144.jpg",
      "../../beachfront-penthouse/54823000.jpg",
      "../../beachfront-penthouse/5962fe43.jpg",
      "../../beachfront-penthouse/596f1d71.jpg",
      "../../beachfront-penthouse/5f708596.jpg",
      "../../beachfront-penthouse/621fd2cf.jpg",
      "../../beachfront-penthouse/6577b88e.jpg",
      "../../beachfront-penthouse/6f62447b.jpg",
      "../../beachfront-penthouse/733198cc.jpg",
      "../../beachfront-penthouse/77578d2a.jpg",
      "../../beachfront-penthouse/77c70694.jpg",
      "../../beachfront-penthouse/7f65f742.jpg",
      "../../beachfront-penthouse/8be2ca4a.jpg",
      "../../beachfront-penthouse/8fc14c1e.jpg",
      "../../beachfront-penthouse/90a80ce9.jpg",
      "../../beachfront-penthouse/9d39da20.jpg",
      "../../beachfront-penthouse/a7ecc702.jpg",
      "../../beachfront-penthouse/a99eaabe.jpg",
      "../../beachfront-penthouse/aa6c7cb9.jpg",
      "../../beachfront-penthouse/ab2e9af6.jpg",
      "../../beachfront-penthouse/ab883824.jpg",
      "../../beachfront-penthouse/ad02222c.jpg",
      "../../beachfront-penthouse/aed9de07.jpg",
      "../../beachfront-penthouse/bfa477b0.jpg",
      "../../beachfront-penthouse/c1118146.jpg",
      "../../beachfront-penthouse/c56a5a7b.jpg",
      "../../beachfront-penthouse/cb1e6dcb.jpg",
      "../../beachfront-penthouse/cf9b8ae6.jpg",
      "../../beachfront-penthouse/d1d7b5f3.jpg",
      "../../beachfront-penthouse/e1851df5.jpg",
      "../../beachfront-penthouse/e829a30c.jpg",
      "../../beachfront-penthouse/e92f539c.jpg",
      "../../beachfront-penthouse/eb41cc5f.jpg",
      "../../beachfront-penthouse/efc1d536.jpg",
      "../../beachfront-penthouse/fe3db5f6.jpg",
    ],
    flagPhoto: "featured/beachfront-penthouse-flag.jpeg",
    route: "/properties/condo-four",
    allowedAdults: 6,
    allowed_guests: 6,
    num_bedrooms: 2,
    num_beds: 4,
    num_baths: 2,
    amenities: {
      essentials: [
        "Wireless Internet",
        "Air conditioning",
        "Heating",
        "Washer",
        "Dryer",
        "Hot water",
        "Toilet paper",
        "Basic soaps",
        "Clean linens provided",
        "Laptop friendly workspace",
        "Smoke alarm",
        "Carbon monoxide alarm",
      ],
      kitchen: [
        "Subzero refrigerator",
        "Wolf stove",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Coffee maker",
        "Toaster",
        "Kettle",
        "Blender",
        "Gas Grill",
        "Wine cooler",
        "Dining table",
      ],
      entertainment: ["Books", "Smart TV", "Jenga"],
    },
    icsUrls: [
      "http://www.vrbo.com/icalendar/3129de24159e4e25aba696425c8570ee.ics?nonTentative",
    ],
  },
  // ... additional houses can be added in the same format
  {
    propertyId: "C204",
    displayName: "Beachfront Condo 1",
    tagline: "Oceanfront 2-bedroom Condo with Private Beach!",
    description:
      "Enjoy a peaceful Cape Cod getaway at this well-maintained two-bedroom, two-bath oceanfront condo in Dennis Port, offering private deeded beach access just steps from your door. Located on the second floor of Building B in an elevator building, the condo features central air conditioning and a comfortable layout designed for relaxed coastal living. The bright, open living space opens to a private balcony with ocean views—perfect for morning coffee, fresh sea air, and unwinding after a day at the beach. A fully equipped kitchen allows you to prepare meals at your own pace, whether it’s a quick breakfast before heading out or a casual dinner in. With two bedrooms and two full bathrooms, the condo provides privacy and flexibility for couples, families, or friends traveling together. The quiet setting and private beach access make it easy to enjoy Nantucket Sound without the crowds or parking concerns of public beaches. While the property feels tucked away and serene, it’s still close to Dennis Port’s restaurants, cafés, and shops, as well as bike paths, boating, golf, and classic Cape Cod attractions. Whether you’re planning a summer beach vacation, a fall coastal retreat, or a quieter off-season escape, this oceanfront condo offers a comfortable and inviting place to enjoy Cape Cod at its best.",
    photos: [
      "../beachfront-condo-1/34-MG_2157-r.jpg",
      "../beachfront-condo-1/32-MG_2147-r.jpg",
      "../beachfront-condo-1/37-MG_2171-r.jpg",
      "../beachfront-condo-1/19-MG_2096-r.jpg",
      "../beachfront-condo-1/46-exterior-1.jpg",
      "../beachfront-condo-1/01-MG_2041-r.jpg",
      "../beachfront-condo-1/09-MG_2067-r.jpg",
      "../beachfront-condo-1/23-MG_2106-r.jpg",
      "../beachfront-condo-1/24-MG_2111-r.jpg",
      "../beachfront-condo-1/27-MG_2121-r.jpg",
      "../beachfront-condo-1/28-MG_2126-r.jpg",
      "../beachfront-condo-1/29-MG_2132-r.jpg",
      "../beachfront-condo-1/30-MG_2136-r.jpg",
      "../beachfront-condo-1/31-MG_2142-r.jpg",
      "../beachfront-condo-1/33-MG_2152-r.jpg",
      "../beachfront-condo-1/35-MG_2162-r.jpg",
      "../beachfront-condo-1/36-MG_2167-r(1).jpg",
      "../beachfront-condo-1/38-MG_2177-r.jpg",
      "../beachfront-condo-1/40-MG_2186-r.jpg",
      "../beachfront-condo-1/42-MG_2196-r.jpg",
      "../beachfront-condo-1/43-MG_2201-r.jpg",
      "../beachfront-condo-1/44-MG_2206-r.jpg",
      "../beachfront-condo-1/46-exterior-1.jpg",
    ],
    flagPhoto: "../beachfront-condo-1/34-MG_2157-r.jpg",
    route: "/properties/condo-204",
    allowedAdults: 4,
    allowedChildren: 3,
    allowed_guests: 4,
    num_bedrooms: 2,
    num_beds: 2,
    num_baths: 2,
    amenities: {
      essentials: [
        "Wireless Internet",
        "Air conditioning",
        "Heating",
        "Washer",
        "Dryer",
        "Hot water",
        "Toilet paper",
        "Basic soaps",
        "Clean linens provided",
        "Laptop friendly workspace",
        "Smoke alarm",
        "Carbon monoxide alarm",
      ],
      kitchen: [
        "Refrigerator",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Coffee maker",
        "Toaster",
        "Kettle",
        "Blender",
        "Gas Grill",
        "Dining table",
      ],
      entertainment: ["Books", "Smart TV"],
    },
    icsUrls: [
      "http://www.vrbo.com/icalendar/11d351bf0a474a3990546173cfeb42cb.ics?nonTentative",
      "https://www.airbnb.com/calendar/ical/1012450350005907448.ics?t=192e5a2bf7524231a308c5d9d43ae63f",
    ],
  },
  {
    propertyId: "C002",
    displayName: "Beachfront Condo 2",
    tagline:
      "Cape Cod Oceanfront Beachfront Condo with Ocean View & Private Sandy Beach!",
    description:
      "A condo brand new in 2013 with spectacular ocean view and private ocean beach on Nantucket Sound! You wake up to the sound of the ocean wave and gorgeous view every morning! Just steps away from the private ocean beach! Master bedroom and kitchen facing ocean directly! Large sliding glass doors from Master bedroom opening to large balcony with spectacular view of Nantucket sound. Master bedroom and guest bedroom each has its own bathroom. Kitchen with eat-in area, granite counter top, and stainless steel appliances overlooking ocean view. Living room with gas fireplace and flat screen TV (Comcast Xfinity). Master Bedroom has a Roku TV. Gleaming hardwood floors. Washer and Dryer inside own unit. End unit on the second floor.",
    photos: [
      "../beachfront-condo-2-view.jpg",
      "../../beachfront-condo-2/2.jpeg",
      "../../beachfront-condo-2/3.jpeg",
      "../../beachfront-condo-2/4.jpeg",
      "../../beachfront-condo-2-gallery/08b1649d.jpg",
      "../../beachfront-condo-2-gallery/1812ff3a.jpg",
      "../../beachfront-condo-2-gallery/403b4f7b.jpg",
      "../../beachfront-condo-2-gallery/4cf9fdff.jpg",
      "../../beachfront-condo-2-gallery/8577201f.jpg",
      "../../beachfront-condo-2-gallery/a00a16e9.jpg",
      "../../beachfront-condo-2-gallery/b8a2ae5f.jpg",
      "../../beachfront-condo-2-gallery/dca42fdd.jpg",
      "../../beachfront-condo-2-gallery/0900726a.jpg",
      "../../beachfront-condo-2-gallery/1c9b10c7.jpg",
      "../../beachfront-condo-2-gallery/40e00b2e.jpg",
      "../../beachfront-condo-2-gallery/5f708596.jpg",
      "../../beachfront-condo-2-gallery/8629663a.jpg",
      "../../beachfront-condo-2-gallery/a6114d7f.jpg",
      "../../beachfront-condo-2-gallery/bd64e33e.jpg",
      "../../beachfront-condo-2-gallery/f34008ef.jpg",
      "../../beachfront-condo-2-gallery/0b3ead88.jpg",
      "../../beachfront-condo-2-gallery/2355c243.jpg",
      "../../beachfront-condo-2-gallery/41a57cbf.jpg",
      "../../beachfront-condo-2-gallery/6132a9af.jpg",
      "../../beachfront-condo-2-gallery/8745adc5.jpg",
      "../../beachfront-condo-2-gallery/a7ecc702.jpg",
      "../../beachfront-condo-2-gallery/bf6a9cbd.jpg",
      "../../beachfront-condo-2-gallery/f5eb57a7.jpg",
      "../../beachfront-condo-2-gallery/0c39717b.jpg",
      "../../beachfront-condo-2-gallery/24c5c203.jpg",
      "../../beachfront-condo-2-gallery/43772569.jpg",
      "../../beachfront-condo-2-gallery/6f62447b.jpg",
      "../../beachfront-condo-2-gallery/87be120d.jpg",
      "../../beachfront-condo-2-gallery/a9272ef6.jpg",
      "../../beachfront-condo-2-gallery/c5d9ee91.jpg",
      "../../beachfront-condo-2-gallery/0d0d81c1.jpg",
      "../../beachfront-condo-2-gallery/35f1de93.jpg",
      "../../beachfront-condo-2-gallery/48f83622.jpg",
      "../../beachfront-condo-2-gallery/7d87f95f.jpg",
      "../../beachfront-condo-2-gallery/8f885555.jpg",
      "../../beachfront-condo-2-gallery/a942aa4c.jpg",
      "../../beachfront-condo-2-gallery/d1b55cf1.jpg",
      "../../beachfront-condo-2-gallery/0e1541d3.jpg",
      "../../beachfront-condo-2-gallery/3b2102a3.jpg",
      "../../beachfront-condo-2-gallery/494f822f.jpg",
      "../../beachfront-condo-2-gallery/806a760f.jpg",
      "../../beachfront-condo-2-gallery/96f4ac70.jpg",
      "../../beachfront-condo-2-gallery/acfd36f5.jpg",
      "../../beachfront-condo-2-gallery/d1d7b5f3.jpg",
      "../../beachfront-condo-2-gallery/0ff1b62f.jpg",
      "../../beachfront-condo-2-gallery/3b4f45cf.jpg",
      "../../beachfront-condo-2-gallery/4bcd6a1e.jpg",
      "../../beachfront-condo-2-gallery/82362104.jpg",
      "../../beachfront-condo-2-gallery/9a9a2cd3.jpg",
      "../../beachfront-condo-2-gallery/ad02222c.jpg",
      "../../beachfront-condo-2-gallery/d6efb064.jpg",
    ],
    flagPhoto: "beachfront-condo-2-view.jpg",
    route: "/properties/condo-two",
    allowedAdults: 10,
    allowedChildren: 1,
    allowed_guests: 4,
    num_bedrooms: 2,
    num_beds: 2,
    num_baths: 2,
    amenities: {
      essentials: [
        "Wireless Internet",
        "Air conditioning",
        "Heating",
        "Washer",
        "Dryer",
        "Hot water",
        "Toilet paper",
        "Basic soaps",
        "Clean linens provided",
        "Laptop friendly workspace",
        "Smoke alarm",
        "Carbon monoxide alarm",
      ],
      kitchen: [
        "Refrigerator",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Coffee maker",
        "Toaster",
        "Kettle",
        "Blender",
        "Gas Grill",
        "Dining table",
      ],
      entertainment: ["Books", "Smart TV"],
    },
    icsUrls: [
      "http://www.vrbo.com/icalendar/39755d1b74ef424ab1cd655eec8c067e.ics?nonTentative",
    ],
  },
  {
    propertyId: "C003",
    displayName: "Beachfront Condo 3",
    tagline:
      "Cape Cod Oceanfront Beachfront New Condo with Ocean View & Private Sandy Beach!",
    description:
      "Brand new 2021 condo: spectacular ocean view and private ocean beach on Nantucket Sound. Living, dining, and kitchen directly facing the ocean! Wake up to the sound of the ocean waves and gorgeous view every morning, just steps away from the private ocean beach! Bedroom #1 has an ocean view with a queen sized bed, an ensuite full bath with shower, and a large window; Bedroom #2 also has an ocean view with a queen sized bed, large window, and a smart TV. Another full bath with shower/tub combo is in the hallway. Large sliding glass doors opening to the large balcony with a spectacular view of Nantucket sound. Kitchen with eat-in area, beautiful countertops, and stainless steel appliances overlooking ocean view. Living room has a smart TV. Central AC, central Heating, Washer and Dryer inside own unit. Linens and bath towels are provided. The unit is located on the third floor. The building has an elevator and stairs.",
    photos: [
      "../beachfront-condo-3-inside.jpeg",
      "../../beachfront-condo-3/028bdf62.jpg",
      "../../beachfront-condo-3/27c3e67d.jpg",
      "../../beachfront-condo-3/5901df54.jpg",
      "../../beachfront-condo-3/7db914de.jpg",
      "../../beachfront-condo-3/9824f5d8.jpg",
      "../../beachfront-condo-3/b8d1a14f.jpg",
      "../../beachfront-condo-3/cad7d79e.jpg",
      "../../beachfront-condo-3/f5eb57a7.jpg",
      "../../beachfront-condo-3/03b5cf2e.jpg",
      "../../beachfront-condo-3/28231526.jpg",
      "../../beachfront-condo-3/5f708596.jpg",
      "../../beachfront-condo-3/7e1cd63b.jpg",
      "../../beachfront-condo-3/aa8fe426.jpg",
      "../../beachfront-condo-3/ba923609.jpg",
      "../../beachfront-condo-3/cf015cd5.jpg",
      "../../beachfront-condo-3/fa81a9cf.jpg",
      "../../beachfront-condo-3/0bddeb70.jpg",
      "../../beachfront-condo-3/2b1f461d.jpg",
      "../../beachfront-condo-3/61c03318.jpg",
      "../../beachfront-condo-3/822b0788.jpg",
      "../../beachfront-condo-3/ac1f8131.jpg",
      "../../beachfront-condo-3/bb8563aa.jpg",
      "../../beachfront-condo-3/d1d7b5f3.jpg",
      "../../beachfront-condo-3/0d0d81c1.jpg",
      "../../beachfront-condo-3/2cf417a2.jpg",
      "../../beachfront-condo-3/61f92890.jpg",
      "../../beachfront-condo-3/87616015.jpg",
      "../../beachfront-condo-3/aca0c7b9.jpg",
      "../../beachfront-condo-3/bbdad711.jpg",
      "../../beachfront-condo-3/d6b97b19.jpg",
      "../../beachfront-condo-3/0e6fbfc6.jpg",
      "../../beachfront-condo-3/46f7b7c8.jpg",
      "../../beachfront-condo-3/6ca9ca3e.jpg",
      "../../beachfront-condo-3/8b3e9acd.jpg",
      "../../beachfront-condo-3/ae2af51f.jpg",
      "../../beachfront-condo-3/c2d550da.jpg",
      "../../beachfront-condo-3/dbb6b82a.jpg",
      "../../beachfront-condo-3/19689768.jpg",
      "../../beachfront-condo-3/4a9deca8.jpg",
      "../../beachfront-condo-3/6f113e3d.jpg",
      "../../beachfront-condo-3/92b49757.jpg",
      "../../beachfront-condo-3/b00d96a2.jpg",
      "../../beachfront-condo-3/c3899605.jpg",
      "../../beachfront-condo-3/e99744fd.jpg",
      "../../beachfront-condo-3/2040d4c9.jpg",
      "../../beachfront-condo-3/527cd9d2.jpg",
      "../../beachfront-condo-3/7d6d64e9.jpg",
      "../../beachfront-condo-3/94b80f3f.jpg",
      "../../beachfront-condo-3/b58c61ae.jpg",
      "../../beachfront-condo-3/c8b36277.jpg",
      "../../beachfront-condo-3/f00b10ec.jpg",
    ],
    flagPhoto: "featured/beachfront-condo-3-flag.jpeg",
    route: "/properties/condo-three",
    allowedAdults: 4,
    allowedChildren: 3,
    allowed_guests: 4,
    num_bedrooms: 2,
    num_beds: 2,
    num_baths: 2,
    amenities: {
      essentials: [
        "Wireless Internet",
        "Air conditioning",
        "Heating",
        "Washer",
        "Dryer",
        "Hot water",
        "Toilet paper",
        "Basic soaps",
        "Clean linens provided",
        "Laptop friendly workspace",
        "Smoke alarm",
        "Carbon monoxide alarm",
      ],
      kitchen: [
        "Refrigerator",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Coffee maker",
        "Toaster",
        "Kettle",
        "Blender",
        "Gas Grill",
        "Dining table",
      ],
      entertainment: ["Books", "Smart TV"],
    },
    icsUrls: [
      "https://www.vrbo.com/icalendar/67c52bffe9674adfa2e1be71d3c31ebe.ics?nonTentative",
    ],
  },
  // ... additional houses can be added in the same format
  {
    propertyId: "C005",
    displayName: "Waterfront House",
    tagline:
      "Beautiful Waterfront Property with a Beach, Dock, Deck, and Fabulous Water Views",
    description: `A spectacular waterfront property! Privately situated at the end of a quiet lane, this home sits on a lush two acres featuring commanding views and frontage on Follins Pond/Bass River with a circular drive way. Enter the front door and be struck by the open grand room featuring cathedral ceilings, and windows overlooking the large patio, beautiful lawn, and fabulous view of the waters. The one level house has 8 rooms with 4 bedrooms and 3 full bathrooms. Enjoy beautiful views of the water from almost every room in the house. The kitchen and a guest bathroom were completely remodeled in 2019. New high efficient Fujitsu Air Conditioning Systems were installed for the whole house in 2019 as well. There is a TV in entertainment room and another TV in master bedroom.

      The property includes a sandy beach that is great for swimming. A canoe, two kayaks, and numerous other water accessories including beach chairs, lifejackets, and paddles are also provided.
      Additionally, the property includes a dock and a boathouse with a full bath right on the edge of the water with a newly built deck around.
      An inviting opportunity for anyone looking to enjoy the incomparable natural amenities of Cape Cod in a beautiful location.`,
    photos: [
      "../waterfront-house-flag.jpg",
      "../../waterfront-house/2.jpeg",
      "../../waterfront-house/3.jpeg",
      "../../waterfront-house/4.jpeg",
      "../../waterfront-house/5.jpeg",
      "../../waterfront-house-gallery/0988aa92.jpg",
      "../../waterfront-house-gallery/270-8daae9d2.jpg",
      "../../waterfront-house-gallery/52ee60e8.jpg",
      "../../waterfront-house-gallery/9317d059.jpg",
      "../../waterfront-house-gallery/c9a8ef50.jpg",
      "../../waterfront-house-gallery/0a3b2532.jpg",
      "../../waterfront-house-gallery/270-9f018522.jpg",
      "../../waterfront-house-gallery/648023df.jpg",
      "../../waterfront-house-gallery/9611441a.jpg",
      "../../waterfront-house-gallery/ca626c8f.jpg",
      "../../waterfront-house-gallery/0d6dde60.jpg",
      "../../waterfront-house-gallery/270-a6f7cffa.jpg",
      "../../waterfront-house-gallery/6d65495e.jpg",
      "../../waterfront-house-gallery/9688c599.jpg",
      "../../waterfront-house-gallery/d945a0c6.jpg",
      "../../waterfront-house-gallery/0f3eb674.jpg",
      "../../waterfront-house-gallery/3346d992.jpg",
      "../../waterfront-house-gallery/7443b54e.jpg",
      "../../waterfront-house-gallery/9deeb4f0.jpg",
      "../../waterfront-house-gallery/dbc8c3fd.jpg",
      "../../waterfront-house-gallery/180-00466a8c.jpg",
      "../../waterfront-house-gallery/389e8d9f.jpg",
      "../../waterfront-house-gallery/795bcddf.jpg",
      "../../waterfront-house-gallery/a63a7fa3.jpg",
      "../../waterfront-house-gallery/de0a444d.jpg",
      "../../waterfront-house-gallery/180-6dafa173.jpg",
      "../../waterfront-house-gallery/41134994.jpg",
      "../../waterfront-house-gallery/7c2f5aa3.jpg",
      "../../waterfront-house-gallery/a7041174.jpg",
      "../../waterfront-house-gallery/e025ad29.jpg",
      "../../waterfront-house-gallery/180-8ade453b.jpg",
      "../../waterfront-house-gallery/4275f5f8.jpg",
      "../../waterfront-house-gallery/804ab66c.jpg",
      "../../waterfront-house-gallery/aaefcf64.jpg",
      "../../waterfront-house-gallery/e342f642.jpg",
      "../../waterfront-house-gallery/180-c59733df.jpg",
      "../../waterfront-house-gallery/42968939.jpg",
      "../../waterfront-house-gallery/84369f2f.jpg",
      "../../waterfront-house-gallery/b48bdf83.jpg",
      "../../waterfront-house-gallery/e8b1e76e.jpg",
      "../../waterfront-house-gallery/1d3cf050.jpg",
      "../../waterfront-house-gallery/44427f22.jpg",
      "../../waterfront-house-gallery/87cd71ad.jpg",
      "../../waterfront-house-gallery/b4f23de8.jpg",
      "../../waterfront-house-gallery/ea7dd620.jpg",
      "../../waterfront-house-gallery/270-34ae759f.jpg",
      "../../waterfront-house-gallery/4a3113c2.jpg",
      "../../waterfront-house-gallery/89c6e0e9.jpg",
      "../../waterfront-house-gallery/b6b334e3.jpg",
      "../../waterfront-house-gallery/ed60a5d1.jpg",
      "../../waterfront-house-gallery/270-471fb7d0.jpg",
      "../../waterfront-house-gallery/4eea2a65.jpg",
      "../../waterfront-house-gallery/8c12b5c6.jpg",
      "../../waterfront-house-gallery/bf904033.jpg",
      "../../waterfront-house-gallery/270-532e8a01.jpg",
      "../../waterfront-house-gallery/4f8488a0.jpg",
      "../../waterfront-house-gallery/8eaaa4aa.jpg",
      "../../waterfront-house-gallery/c36b5b73.jpg",
    ],
    flagPhoto: "waterfront-house-flag.jpg",
    route: "/properties/lake-one",
    allowedAdults: 8,
    allowedChildren: 7,
    allowed_guests: 8,
    num_bedrooms: 4,
    num_beds: 5,
    num_baths: 4,
    amenities: {
      essentials: [
        "Wireless Internet",
        "Heating",
        "Washer",
        "Dryer",
        "Hot water",
        "Toilet paper",
        "Basic soaps",
        "Clean linens provided",
        "Laptop friendly workspace",
        "Smoke alarm",
        "Carbon monoxide alarm",
      ],
      kitchen: [
        "Refrigerator",
        "Microwave",
        "Dishwasher",
        "Dishes and silverware",
        "Cooking basics",
        "Oven",
        "Coffee maker",
        "Toaster",
        "Kettle",
        "Blender",
        "Gas Grill",
        "Dining table",
      ],
      entertainment: [
        "Books",
        "Smart TV",
        "Puzzles and games",
        "DVD player",
        "Kayaking",
        "Canoeing",
        "Fishing",
        "Swimming",
        "Beach chairs",
        "Beach towels",
        "Beach umbrellas",
        "Life jackets",
        "Paddle boards",
        "Paddles",
      ],
    },
    icsUrls: [
      "http://www.vrbo.com/icalendar/cc21afdd18514ef2958390102ed5fdf2.ics?nonTentative",
    ],
  },
];

/** Keyed by property id. It used to be keyed by unit number, which put those
 *  numbers into the shipped bundle; guests should never see which unit is
 *  which. Resolved by id rather than array position so reordering `houses`
 *  cannot silently repoint a page at the wrong house. */
export const housesDict: HouseDictionary = Object.fromEntries(
  houses.map((house) => [house.propertyId, house]),
);

/** Photo paths are stored relative to whichever page renders them; this turns
 *  one into an absolute path that works from any route. */
export const toPublicSrc = (path: string): string =>
  `/${path.replace(/^(\.\.?\/)+/, "").replace(/^\/+/, "")}`;

export default houses;
